import { Box, Button, Grid } from '@mui/material';
import { IComponentCss, PeriodSelectType } from '@tap/mui-ui';
import { IssueDecisionTimeReportResult } from '@tap/data-providers';
import IssueDecisionTimeChart from './IssueDecisionTimeChart';
import IssueDecisionTimeTable from './IssueDecisionTimeTable';

/* Отчёт Время на решение заявок
*/

// Стили
const css: IComponentCss = {
    contentWrap: {
        position: 'relative',
        display: 'inline-grid',
        width: '100%',
    },
    optionsButton: {
        marginBottom: '5px',
        float: 'right',
    },
    chartWrap: {
        width: '90%',
        marginBottom: '40px',
    },
};

type IssueDecisionTimeReportProps = {
    periodType: PeriodSelectType,
    reportData: IssueDecisionTimeReportResult[],
    onOptionsButtonClick: () => void,
};

export default function IssueDecisionTimeReport({ periodType, reportData, onOptionsButtonClick }: IssueDecisionTimeReportProps) {

    return (
        <Box sx={css.contentWrap}>
            <Grid>
                <Button
                    size='small'
                    sx={css.optionsButton}
                    onClick={onOptionsButtonClick}
                >
                    Параметры отчёта
                </Button>
            </Grid>
            <Grid sx={css.chartWrap}>
                <IssueDecisionTimeChart
                    reportData={reportData}
                    periodType={periodType}
                />
            </Grid>
            <IssueDecisionTimeTable reportData={reportData} />
        </Box>
    );
}

